module.exports = __webpack_public_path__ + "static/ig-banner-square-2-189dabbf6908b21daedfc49cc0314ae1.jpg";